<template>
  <div id="app">
    <RouterView />
  </div>
</template>

<script setup>
import { watch } from 'vue'
import { RouterView } from 'vue-router'
import { useThemeStore } from '@/stores/theme'

const themeStore = useThemeStore()

function applyTheme(dark) {
  document.documentElement.classList.toggle('dark', dark)
}

// Apply immediately on load
applyTheme(themeStore.isDark)

// Keep in sync when toggled
watch(() => themeStore.isDark, applyTheme)
</script>
